import * as yup from "yup"

const ContactUsschema = yup
  .object({
    name: yup.string().required(),
    email: yup.string().required().matches(/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/,"Invalid mail format"),
    message:yup.string().required()
  })
  .required()
export default ContactUsschema